module.exports = __webpack_public_path__ + "media/components/smartbar/static/icon-close-b12cf33426dafdd22fb4181d27fcb3ca.svg";